module.exports = __webpack_public_path__ + "img/bar_03.287868e9.jpg";